import React from 'react'

import { StatusTag } from '../../../../../components/common/StatusTag'
import type { Status } from '../../../../../consts/status'
import * as S from './styled'

type ProductStatusProps = {
  status: 'PUBLIC' | 'HIDDEN' | 'ARCHIVED'
  soldOut: boolean
}

export const ProductStatus = ({ status, soldOut }: ProductStatusProps) => (
  <S.Tags>
    <S.Tag>
      <StatusTag status={status.toUpperCase() as Status} isSoldOut={soldOut} />
    </S.Tag>
  </S.Tags>
)
